import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import packageJson from "../../package.json";

const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;

if (apiKey) {
  try {
    Bugsnag.start({
      apiKey,
      appType: "frontend",
      appVersion: packageJson.version,
      plugins: [new BugsnagPluginReact()],
      releaseStage: import.meta.env.MODE,
      onError(event) {
        event.addMetadata("app", {
          service: "frontend",
          environment: import.meta.env.MODE,
        });
      },
    });
  } catch {
    // Ignore telemetry startup failures so the app can still render normally.
  }
}

export const bugsnagEnabled = Boolean(apiKey);

export default Bugsnag;
